import {getCookie, setCookie} from "./core";

window.$ = window.jQuery = require('jquery');
window.Popper = require('popper.js').default;
window.axios = require('axios').default;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.Vue = require('vue');
require('bootstrap');
require('../plugins/bootstrap-button/bootstrap-button.min');
require('datatables.net-dt');
require('datatables.net-responsive/js/dataTables.responsive');
window.axios = require('axios').default;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

// DataTables global settings
let locale = getCookie('language-js');
locale = (locale === null || locale === '') ? 'en_US' : locale;

$.fn.dataTable.ext.errMode = 'none'; // Changed from 'throw' to 'none' to prevent console errors

$.extend(true, $.fn.dataTable.defaults, {
    lengthMenu: [[10, 25, 50, 100, 250], [10, 25, 50, 100, 250]],
    processing: true,
    deferRender: true,
    searching: false,
    ordering: false,
    language: {
        url: "/i18n/datatables/" + locale + ".lang",
        dataType: 'json' // Explicitly set data type to JSON
    }
});